<template>
  <div>
    <div class="tw:flex tw:items-start tw:md:items-center">
      <label class="tw:flex tw:justify-center tw:items-center tw:mb-0">
        <input
          :id="uniqueId"
          :checked="value"
          type="checkbox"
          class="tw:hover:cursor-pointer"
          v-bind="$attrs"
          @blur="emit('onBlur', $event.target.checked)"
          @change="emit('onChange', $event.target.checked)"
          :data-testid="dataTestId"
        />
        <span
          :class="{ 'tw:mb-0': !label }"
          class="tw:mb-0 tw:ml-2 tw:hover:cursor-pointer label-text"
          v-html="label.length > 0 ? $t(label) : ''"
        />
      </label>
    </div>
    <small v-if="error" class="tw:text-red-700">{{ error }}</small>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const emit = defineEmits(['onBlur', 'onChange'])
const props = defineProps({
  id: {
    type: String,
  },
  label: {
    type: String,
    required: false,
    default: '',
  },
  value: {
    type: Boolean,
    required: true,
  },
  error: {
    type: [Boolean, String],
    default: false,
  },
  dataTestId: {
    type: String,
    default: '',
  },
})

const generatedId = `checkbox-${Math.random().toString(36).slice(2, 11)}`
const uniqueId = computed(() => props.id || generatedId)
</script>
<style scoped>
input {
  border-color: var(--tw-color-gray-500);
}
label :deep(a) {
  color: var(--tw-color-blue-800);
}
</style>
